import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbChevronRight: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 14, ...props }) => {
  return (
    <>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill={fill} {...props}>
        <g id='Box'>
          <rect fill='none' width={size} height={size} />
        </g>
        <g id='Final_icons_-_Common' data-name='Final icons - Common'>
          <polygon points='9 18 15.01 12.01 9 6 10.5 4.5 18.01 12.01 10.5 19.5 9 18' />
        </g>
      </svg>
    </>
  );
};
